import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminEmailLogsPage, type AdminEmailLogsPageProps } from '../ui/admin/AdminEmailLogsPage';

export function AdminEmailLogsPageContainer(props: AdminEmailLogsPageProps) {
  return <AdminEmailLogsPage {...props} />;
}

export function mountAdminEmailLogsPage(
  container: HTMLElement,
  props: AdminEmailLogsPageProps
) {
  const root = createRoot(container);
  root.render(<AdminEmailLogsPageContainer {...props} />);
  return root;
}

export default AdminEmailLogsPageContainer;
